import { isSoftPhoneActive, useSoftPhone } from '@/contexts/softPhoneContext';
import useChromeSettings from '@/hooks/useChromeSettings';

interface MicPermissionResult {
  micNotApproved: boolean;
  micMessage: string;
  openSettings: ((url: string) => void) | null;
  extensionSettingsUrl: string | null;
  siteSettingsUrl: string;
}

const useMicPermission = (): MicPermissionResult => {
  const softPhone = useSoftPhone();
  const { openSettings, extensionSettingsUrl, siteSettingsUrl, isInExtension } =
    useChromeSettings();

  const micPermission = isSoftPhoneActive(softPhone) ? softPhone.micPermission : undefined;
  const micNotApproved = isInExtension && micPermission !== 'granted';
  const micMessage =
    micPermission === 'denied'
      ? 'Microphone access is blocked.'
      : 'Microphone permission is required.';

  return { micNotApproved, micMessage, openSettings, extensionSettingsUrl, siteSettingsUrl };
};

export default useMicPermission;
